export const getStyled = (theme, open) => ({
  ticket: {
    position: 'relative',
    margin: '6px -6px 6px 6px',
    borderRadius: '8px',
    backgroundColor: theme.palette.mode === 'light' ? '#f2f2f2' : '#213445',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    maxWidth: '100%',

    '&:hover': {
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
      backgroundColor: theme.palette.mode === 'light' ? '#f2f2f2' : '#294056',
      transform: 'translateY(-2px)',
      cursor: 'pointer',
    },

    '@media (minResolution: 1.2dppx)': {
      maxWidth: '100%',
    },
  },

  responsiveText: {
    fontWeight: 600,
    fontSize: '14px',

    fontFamily: 'Tahoma, sans-serif',

    '@media (minResolution: 1.2dppx)': {
      fontSize: '0.8rem',
    },
  },
  pendingTicket: {
    cursor: 'pointer',
  },
  queueTag: {
    background: '#FCFCFC',
    color: '#000',
    marginRight: 1,
    padding: 1,
    fontWeight: 'bold',
    borderRadius: 3,
    fontSize: '0.5rem',
    whiteSpace: 'nowrap',
  },
  noTicketsDiv: {
    display: 'flex',
    height: '100px',
    margin: 40,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  newMessagesCount: {
    justifySelf: 'flex-end',
    position: 'relative',
    top: '0',
    color: 'green',
    fontWeight: 'bold',
    marginRight: '10px',
  },
  noTicketsText: {
    textAlign: 'center',
    color: 'rgb(104, 121, 146)',
    fontSize: '14px',
    lineHeight: '1.4',
  },
  connectionTag: {
    background: 'green',
    color: '#FFF',
    marginRight: '2px',
    fontWeight: 'bold',
    borderRadius: 2,
    fontSize: '0.6em',
    padding: '0 5px',

    '@media (minResolution: 1.2dppx)': {
      paddingTop: '1px !important',
      fontSize: '0.5rem',
    },
  },
  noTicketsTitle: {
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: '600',
    margin: '0px',
  },
  contactNameWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginLeft: '5px',
    fontWeight: 'bold',
    color: theme.palette.mode === 'light' ? 'black' : 'white',

    '@media (minResolution: 1.2dppx)': {
      marginLeft: '-4px',
    },
  },
  lastMessageTime: {
    justifySelf: 'flex-end',
    textAlign: 'right',
    position: 'relative',
    top: -30,
    marginRight: '1px',
    color: theme.palette.mode === 'light' ? 'black' : '#bdbdbd',
  },
  closedBadge: {
    alignSelf: 'center',
    justifySelf: 'flex-end',
    marginRight: 32,
    marginLeft: 'auto',
  },
  contactLastMessage: {
    paddingRight: '0%',
    marginLeft: '5px',
    color: theme.palette.mode === 'light' ? 'black' : '#bdbdbd',
    fontFamily: 'Tahoma, sans-serif !important',

    '@media (minResolution: 1.2dppx)': {
      fontSize: '0.7rem',
    },
  },
  contactLastMessageUnread: {
    paddingRight: 20,
    fontWeight: 'bold',
    color: theme.palette.mode === 'light' ? 'black' : '#bdbdbdbd',
    width: '50%',
    fontFamily: 'Tahoma, sans-serif !important',
  },
  badgeStyle: {
    '& .MuiBadge-badge': {
      color: 'white',
      backgroundColor: '#4caf50',
      top: open ? '55%' : '50%',
    },
  },
  ticketQueueColor: {
    flex: 'none',
    height: '100%',
    position: 'absolute',
    top: '0%',
    left: '0%',
  },
  itemAvatar: {
    margin: open ? '0 7px 0 -5px' : '0 -5px 0 -18px',

    '@media (minResolution: 1.2dppx)': {
      margin: open ? '0 10px 0 -10px' : '0 0 0 -19px',
    },
  },
  avatar: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    transform: open ? 'scale(1.2)' : 'scale(0.75)',

    '@media (minResolution: 1.2dppx)': {
      transform: open ? 'scale(1)' : 'scale(0.65)',
    },
  },
  ticketInfo: {
    position: 'relative',
    top: -13,
  },
  secondaryContentSecond: {
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'nowrap',
    flexDirection: 'row',
    alignContent: 'flex-start',

    '@media (minResolution: 1.2dppx)': {
      fontSize: '12px',
    },
  },
  actionBtn: {
    position: 'relative',
    backgroundColor: 'transparent',
    boxShadow: 'none',
    border: 'none',
    borderRadius: '50%',
    fontSize: '1rem',
    minWidth: 'auto',
    padding: 0,
    bottom: open ? '-1.5rem' : '-1.2rem',
    transform: 'translateX(-15px)',

    '@media (minResolution: 1.2dppx)': {
      transform: 'scale(0.8) translateX(-15px)',
      margin: '-0.15rem',
    },

    '&:hover': {
      backgroundColor: 'rgb(255,255,255,0.15)',
    },
  },
  fixActionBtn: {
    position: 'absolute',
    backgroundColor: 'transparent',
    boxShadow: 'none',
    border: 'none',
    borderRadius: '50%',
    fontSize: '1rem',
    minWidth: 'auto',
    padding: 0,
    top: 0,
    left: '0.75rem',
    transform: 'translateX(-15px)',
    color: 'white',
    display: 'flex',

    '@media (minResolution: 1.2dppx)': {
      transform: 'scale(0.8) translateX(-15px)',
      margin: '-0.15rem',
    },
  },
  ticketIcon: {
    fontSize: '24px',
  },
  ticketInfo1: {
    position: 'relative',
    top: 13,
    right: 0,
  },
  Radiusdot: {
    '& .MuiBadgeBadge': {
      borderRadius: 2,
      position: 'inherit',
      height: 16,
      margin: 2,
      padding: 3,
    },
    '& .MuiBadgeAnchorOriginTopRightRectangle': {
      transform: 'scale(1) translate(0%, -40%)',
    },
  },
  connectionIcon: {
    position: 'absolute',
    top: 5,
    marginRight: theme.spacing(1),
  },
  interactionTime: {
    fontSize: '0.75rem',
    fontWeight: 'bold',
    marginLeft: '4px',
    justifySelf: 'flex-end',
  },
  recent: { color: '#42a5f5' },
  warning: { color: '#ff9800' },
  critical: { color: '#f44336' },
  ticketIconOpen: {
    color: '#4caf50',
  },
  pinIcon: {
    transform: 'scale(0.8)',
    alignSelf: 'center',
    justifySelf: 'center',
  },
  ticketIconClose: {
    color: '#4caf50',
  },
  ticketIconTransfer: {
    color: '#ff9800',
  },
  ticketIconCancel: {
    color: '#e53935',
  },
  ticketIconReopen: {
    color: theme.palette.mode === 'light' ? '#1DA1F2' : '#FFF',
  },
});
